<template>
    <div class="activity-indicator-square" />
</template>